import apiService from '@/utils/api-client'

export default {
  async getMultiChainTxInfo(_, { extended = false, type, input, chains = [], onUpdate }) {

    const checkEndpoint = async (base, checkType, key, essential) => {
      // const url = `${base}/explorer/recognize?${checkType}=${input}&extended=${extended}`
      onUpdate({ type: checkType, key, essential, data: null, error: null, loading: true })

      try {
        // const res = await apiService.get(url)
        const url = '/explorer/recognize'

        const res = await apiService.get(url, {
          baseURL: base,
          params: {
            [checkType]: input,
            extended
          }
        })
        return { success: res?.exists, res, error: null }
      } catch (err) {
        const errorData = err.response?.data ?? { message: err.message || 'Unknown error' }
        return { success: false, res: null, error: errorData }
      }
    }

    const runChain = async (chain) => {
      const { baseUrl, key, essential } = chain
      const base = baseUrl.replace(/\/$/, '')
      const shouldCheckTx = type === 'tx_hash' || (!type && chain.checkTx)
      const shouldCheckAddress = type === 'address' || (!type && chain.checkAddress)

      let lastRes = null
      let lastErr = null
      let matchedType = null

      if (shouldCheckTx) {
        const { success, res, error } = await checkEndpoint(base, 'tx_hash', key, essential)
        if (success) {
          onUpdate({ type: 'tx_hash', key, essential, data: res, error: null, loading: false })
          return { res, isTx: true }
        }
        lastRes = res
        lastErr = error
        matchedType = 'tx_hash'
      }

      if (shouldCheckAddress) {
        const { success, res, error } = await checkEndpoint(base, 'address', key, essential)
        if (success) {
          onUpdate({ type: 'address', key, essential, data: res, error: null, loading: false })
          return { res, isTx: false }
        }
        lastRes = res
        lastErr = error
        matchedType = 'address'
      }

      onUpdate({ type: matchedType, key, essential, data: lastRes, error: lastErr, loading: false })
      return { res: lastRes, isTx: false }
    }

    const advancedChains = chains.filter(c => !c.essential)
    const essentialChains = chains.filter(c => c.essential)

    if (type === 'address') {
      await Promise.all(chains.map(runChain))
    }
    else {
      const advancedResults = await Promise.all(advancedChains.map(runChain))

      if (advancedResults.some(r => r.res?.exists && r.isTx)) return

      if (essentialChains.length) {
        for (const chain of essentialChains) {
          const { res, isTx: foundTx } = await runChain(chain)

          if (res?.exists && foundTx) {
            break
          }
        }
      }
    }
  }
}
